import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  donationTypeTitle: {
    id: 'donater.form.donationType.title',
    defaultMessage: 'Donation Type',
  },
  donationText: {
    id: 'donater.form.donationType.text',
    defaultMessage: 'Text',
  },
  donationAudio: {
    id: 'donater.form.donationType.audio',
    defaultMessage: 'Audio',
  },
  payToAdd: {
    id: 'donater.form.pay_to_add',
    defaultMessage: 'To add a {type}, {action} to the donation amount ',
  },
})
